
import {
  Component, PropSync, Prop, Mixins,
} from 'vue-property-decorator';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class ConfirmationDialog extends Mixins(focusMixin) {
  protected focusConfirmButtonOnOpen = false;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: false, default: '' }) btnText!: string;

  @Prop({ required: false, default: '' }) dialogTitle!: string;

  mounted() {
    const dialog = this.$refs.confirmDialog as any;
    if (dialog) {
      dialog.stackMinZIndex = 20000;
    }
  }

  private perform() {
    eventBus.$emit(eventNames.CONFIRMATION_DIALOG);
    this.close();
  }

  private reject() {
    eventBus.$emit(eventNames.CONFIRMATION_DIALOG_REJECTED);
    this.close();
  }

  private close() {
    eventBus.$off(eventNames.CONFIRMATION_DIALOG);

    this.$store.commit('toggleConfirmDialog', {
      show: false,
      content: '',
      btnText: '',
      title: '',
    });
  }
}
